import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { getButtonStyleClass } from './utils';

export enum ButtonVariant {
  Primary = 'Primary',
  Secondary = 'Secondary',
  Danger = 'Danger',
  Success = 'Success',
  Grayscale = 'Grayscale',
  Transparent = 'Transparent',
}
export interface ButtonProps {
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  variant?: ButtonVariant;
  dataTestId?: string;
  children?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  name?: string;
  value?: string | number | readonly string[];
  id?: string;
  tabIndex?: number;
  form?: string;
}

export const BUTTON_CLASS = {
  BASE: 'rounded-full flex items-center justify-center px-4 sm:px-5 py-2 sm:py-3 font-semibold text-xs sm:text-sm transition-colors border gap-4',

  SECONDARY: 'bg-primary-50 text-primary-500 border-primary-500',
  PRIMARY: 'bg-primary-500 text-white border-primary-500',
  DANGER: 'bg-danger-500 text-white border-danger-500',
  SUCCESS:
    'bg-secondaryGreen-50 text-secondaryGreen-500 border-secondaryGreen-500',
  GRAYSCALE: 'bg-neutral-30 text-neutral-80 border-neutral-30 font-normal',
  TRANSPARENT: 'text-info-500 font-semibold border-transparent',
  DISABLED: 'bg-neutral-50 text-neutral-70 border-neutral-50',
};

const Button: FC<ButtonProps> = ({
  onClick,
  className,
  disabled = false,
  variant = ButtonVariant.Primary,
  dataTestId = 'button',
  children,
  type = 'button',
  name,
  value,
  id,
  tabIndex,
  form,
}) => {
  const buttonStyleClass = getButtonStyleClass(variant, disabled);

  return (
    <button
      tabIndex={tabIndex}
      id={id}
      value={value}
      name={name}
      type={type}
      disabled={disabled}
      data-testid={dataTestId}
      className={twMerge(BUTTON_CLASS.BASE, buttonStyleClass, className)}
      onClick={onClick}
      form={form}
    >
      {children}
    </button>
  );
};

export default Button;
